import React, { Component } from 'react';
import propTypes from 'prop-types';

import { registerClickAwayHandler, unregisterClickAwayHandler } from 'util/clickAway';
import OptionDeviceTrigger from '../triggers/OptionDeviceTrigger';

// components
import { Popover } from 'react-bootstrap';

class ExportSendToDrivePopover extends Component {
  componentDidMount() {
    registerClickAwayHandler(this, this.props.onClickAwayFromExportOptions);
  }

  componentWillUnmount() {
    unregisterClickAwayHandler(this);
  }
  render() {
    return (
      this.props.isSendToDriveOpen ? (
        <Popover
          id='export-options'
          placement={
            this.props.bulkExportOptionsIsOpen || this.props.scriptCreatorExportOptionsIsOpen
              ? 'bottom'
              : 'right'
          }
        >
          <OptionDeviceTrigger 
            driveDevices={this.props.driveDevices}
            isSendToDriveOpen={this.props.isSendToDriveOpen}
            onClickDeviceOption={this.props.onClickDeviceOption}
          />
        </Popover>
      ): null
    );
  }
}

ExportSendToDrivePopover.propTypes = {
  bulkExportOptionsIsOpen: propTypes.bool.isRequired,
  driveDevices: propTypes.arrayOf(propTypes.shape({
    description: propTypes.string,
    deviceModelId: propTypes.string,
    id: propTypes.string,
    name: propTypes.string
  })),
  isSendToDriveOpen: propTypes.bool.isRequired,
  onClickAwayFromExportOptions: propTypes.func.isRequired,
  onClickDeviceOption: propTypes.func.isRequired,
  scriptCreatorExportOptionsIsOpen: propTypes.bool.isRequired
};

export default ExportSendToDrivePopover;
